import services from './../../services/service'; // Service Class
import Settings from './../../components/tools/settings.vue';
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
        path: (this.$route.path).replace('/',''),
        user: {},
        user_slug: {},
        market:{},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false,
        server_query_done:false,
        navw:false
      }
  },
  
  components: {
    'c-settings':Settings,

},
methods: {
    back(){
        window.history.back();
    },
    show_nav(){
        document.getElementById("main-nav-bar").style.display = "block";
        this.navw = true;
    },
    hide_nav(){
        document.getElementById("main-nav-bar").style.display = "none";
        this.navw = false;
    },
    navggle(){
        let status = document.getElementById("main-nav-bar").style.display;
        if(status == "none"){
            document.getElementById("main-nav-bar").style.display = "block";
        }else{
            document.getElementById("main-nav-bar").style.display = "none";
       }
    },
    display_menu(){
        let status = document.getElementById("main-nav-bar").style.display;
        if(status == "none"){
            document.getElementById("main-nav-bar").style.display = "block";
        }else{
            document.getElementById("main-nav-bar").style.display = "none";
        }
        
    },

    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user = localStorage.getItem("sp_user");
        }
    },

    preset() {
        var credentials = {
            session_key: localStorage.getItem("sp_token")
        } 
        if(credentials.session_key != null) {
            service.sessionGuard(this, credentials).then(response => {
                if(response.body.status == 200) {
                    this.server_query_done = true;
                    let data = response.body.data;
                    data.forEach(function(element) {
                        this.user.user_id = element.user_id;
                        this.user.user_name = localStorage.getItem("sp_user");
                        this.loggedIn = true;//loggedIn options
                    }, this);
                }else {
                  //  console.log(response)
                 //// this.$router.push('/login/');
                  }
                  this.server_query_done = true;
            }).catch((err) => {
                if(err) {
                    this.server_query_done = true;
                    // console.log(err)
                    //this.$router.push('/login/');
                }
            })
        }else {
           //console.log("error 2")
          // this.$router.push('/login/');
          this.server_query_done = true;
        }
    },

    setMarketRemote(){
        service.getBusinessByUserName(this, "").then(response => {
            if(response.body.status == 200) {
                this.market = response.body.data;
            }
        }).catch((err) => {
            //maybe no connection ..load from local
           // this.setSellpointLocal(); //removed...caused slower loading
        })
        
    },


    setMarketLocal(){},

    
  },
  created: function() {
    this.checkLoggedIn();
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainHeader/script.js